import React from "react";
import { FormattedMessage } from "react-intl";

const Hifz = () => {
  return (
    <>
      <div className="Title">
        <FormattedMessage id="favorites" />
      </div>
      <div>Favorites are shown here.</div>
    </>
  );
};

export default Hifz;
